export default __webpack_public_path__ + "static/quarters-d17720997e49e2aba62c567980534ce5.png";